import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { Card, CardActionArea, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import Roles from '../../HomeViewRoles';
import Styles from './ProjectCard.scss';

const CreateProjectCard = (props) => {
    return (
        <Card className={Styles.pcContainer}>
            <CardActionArea
                id="create-project-card"
                className={Styles.pcContent}
                onClick={props.onClick}
                role={Roles.createProjectCard}
            >
                <div className={Styles.pcContentContainer}>
                    <div className={Styles.pcMediaContainer}>
                        {/* <AddOutlinedIcon className={Styles.pcProjectIcon} /> */}
                        <div className={Styles.pcMediaTextContainer}>
                            <span>+</span>
                        </div>
                    </div>

                    <div className={Styles.pcCreateTitleContainer}>
                        <span
                            id="create-project-card-title"
                            className={Styles.pcTitle}
                        >
                            New Project
                        </span>
                    </div>
                </div>
            </CardActionArea>
        </Card>
    );
};

CreateProjectCard.propTypes = {
    onClick: PropTypes.func,
};
export default CreateProjectCard;
